import * as React from "react";
import {cs} from "../../../../../../../react/chain-services";
import "./step-2-customize.scss";
import {Header} from "../../common/header/header";
import {Form} from "./form/form";
import {cx} from "emotion";
import {last} from "../../../../../../../utils/collections";
import {UseState} from "../../../../../../../react/use-state";

export const Step2Customize = ({config, initCustomization, onBack, onNext, query}) => cs(
    ["customization", (_, next) => UseState({
        initValue: initCustomization,
        next: (s) => next({
            ...s,
            value: {
                ...getDefaultInputsCustomizations(config),
                ...s.value,
            },
        }),
    })],
    ["form", ({customization}, next) => Form({
        config,
        state: customization,
        next,
    })],
    ["showErrors", (_, next) => UseState({next})],
    ({customization, form, showErrors}) => (
        <div className="step-2-customize-30f">
            {Header({
                icon: require("../../../../mailing-icons/listtype-demographics.png"),
                title: "Demographics Search",
                subTitle: "Create a list around demographic filters.",
            })}

            <div className="content">
                <div className="prev-section">

                    <div className="title" xd-qa-type="label" xd-qa-name="Demographics Search Select Target">
                        Select Target
                    </div>
                    <a className="edit" onClick={onBack} xd-qa-type="link" xd-qa-name="Demographics Search Edit">
                        Edit
                    </a>
                </div>

                <div className="customize-section">
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Demographics Search Customize your Search">
                            Customize your Search
                        </div>
                    </div>

                    <div className="box">
                        {form.render({
                            showErrors: showErrors.value,
                        })}
                    </div>
                </div>
            </div>

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: onBack,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Demographics Search Back",
                }}>
                    Back
                </button>

                <button {...{
                    className: cx("next", {
                        disabled: form.invalid,
                    }),
                    onClick: () => {
                        query.onChange(null)
                        if (form.invalid) {
                            if (!showErrors.value) {
                                showErrors.onChange(true);
                            }
                            form.highlightErrors();
                        } else {
                            onNext(customization.value);
                        }
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Demographics Search Next",
                }}>
                    Next
                </button>
            </div>
        </div>
    ),
);


const getDefaultInputsCustomizations = (config) => {
    return Object.keys(config).reduce((v, key) => {
        const fieldConfig = config[key];
        if (fieldConfig.targetType === "rangeType") {
            return {
                ...v,
                [key + "_low" ]: fieldConfig.values.low[0],
                [key + "_high"]: last(fieldConfig.values.high),
            };
        }
        return v;
    }, {});
};
